import React from "react"
import { Alert } from "antd"

import { W1 } from "@components/constants"

import Markdown from "./Markdown"


const MarkdownAlert = ({ text, type }) => {
  return (
    <Alert
      type={type}
      style={{ marginBottom: W1, paddingTop: 0, paddingBottom: 0 }}
      message={
        <Markdown text={text} />
      }
    />
  )
}

export default MarkdownAlert
